import { DynamicQuery } from 'common/dynamicquery/dynamic-query-class';
/* eslint-disable no-var */
/* eslint-disable guard-for-in */
export function DynamicQueryContainer(queryCreatedCallback, queryClosedCallback, queryResetCallback) {

  var self = {
    create: create,
    get: getById,
    closeAll: closeAllQueries,
    resetAll: resetAll,
    isQueryDeleted: isQueryDeleted
  };

  /*
   entry.Id = dynamic query ID
   entry.Hash = hash
   entry.Refs = references to the same dynamic query
   */
  var queryEntriesById = {};
  var pendingQueryDeletions = [];

  function create(query, values) {
    var dqEntry = _getQueryEntry(query, values);

    dqEntry.Refs++;

    return dqEntry.Query;
  }

  function getById(id) {
    var dqEntry = queryEntriesById[id];

    if (dqEntry) {
      return dqEntry.Query;
    }
  }

  function closeAllQueries() {
    const closePromises = [];
    for (var id in queryEntriesById) {
      if (queryEntriesById[id]) {
        // Hack for new id system - API 2.0
        queryEntriesById[id].Refs = 1;
        closePromises.push(queryEntriesById[id].Query.close());
      }
    }
    return closePromises;
  }

  function resetAll() {
    for (var id in queryEntriesById) {
      if (queryEntriesById[id]) {
        queryCreatedCallback(queryEntriesById[id].Query);
      }
    }
  }

  function isQueryDeleted(id) {
    return pendingQueryDeletions.indexOf(id) > -1;
  }

  function _getQueryEntry(query, values) {
    var hash = _hash(query, values);
    var dqEntry = _getQueryEntryByHash(hash);

    if (!dqEntry) {
      dqEntry = _createNewDynamicQueryEntry(query, values, hash);
      queryCreatedCallback(dqEntry.Query);
    }

    return dqEntry;
  }

  function _getQueryEntryByHash(hash) {
    // TODO: optimize if necessary
    for (var id in queryEntriesById) {
      var queryEntry = queryEntriesById[id];
      if (queryEntry && queryEntry.Hash === hash) {
        return queryEntry;
      }
    }
  }

  function _createNewDynamicQueryEntry(query, values, hash) {
    var dq = new DynamicQuery(query, values, _closeQuery, _resetQuery);

    var entry = {
      Query: dq,
      Hash: hash,
      Refs: 0
    };

    queryEntriesById[dq.id] = entry;
    return entry;
  }

  function _closeQuery(dq) {
    var dqEntry = queryEntriesById[dq.id];

    // Check if the DynamicQuery is found
    if (dqEntry && dqEntry.Refs) {
      dqEntry.Refs--;

      if (dqEntry.Refs === 0) {
        // TODO: put them away in a collection of unused queries and close them once the timeout is up...
        queryEntriesById[dq.id] = void 0;
        pendingQueryDeletions.push(dq.id);
        return queryClosedCallback(dq)
          .then(function() {
            var i = pendingQueryDeletions.indexOf(dq.id);
            if (i > -1) {
              pendingQueryDeletions.splice(i, 1);
            } else {
              console.error('Dynamic query deleted twice.');
            }
          });
      }
    }
    return Promise.resolve();
  }

  function _resetQuery(dq) {
    return queryResetCallback(dq);
  }

  /*
   * Generate hash from query and values to identify DynamicQueries
   */
  function _hash(query, values) {
    let last = null;
    let q = query;
    while (true) {  // eslint-disable-line no-constant-condition
      let next = null;
      for (let j in values) {
        if ((!next || j < next) && (!last || j > last)) {
          next = j;
        }
      }
      if (!next) {
        break;
      }

      q += '-' + next + '-' + (values[next] || '');
      last = next;
    }
    return q;
  }

  return self;
}
